// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
function getSetVh() { 
    const roundedVh = Math.round(window.visualViewport.height * 0.01); 
    document.body.style.setProperty('--vh', `${roundedVh}px`) 
}

// Browser check
// Browser and device detection
function getNavigator() {
    const html = document.documentElement;
    
    // Feature-based detection
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    const isChrome = /Chrome/.test(navigator.userAgent) && !/Edge|Edg/.test(navigator.userAgent);
    const isFirefox = /Firefox/.test(navigator.userAgent);
    const isEdge = /Edge|Edg/.test(navigator.userAgent);
    
    // Touch support detection
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Apply classes
    if (isiOS) html.classList.add('ios');
    if (hasTouch) html.classList.add('touch');
    
    // Browser classes and events
    const browsers = [
        { test: isSafari, name: 'safari' },
        { test: isChrome, name: 'chrome' },
        { test: isFirefox, name: 'firefox' },
        { test: isEdge, name: 'edge' }
    ];
    
    browsers.forEach(({ test, name }) => {
        if (test) {
            html.classList.add(name);
            window.dispatchEvent(new CustomEvent('user-agent', { detail: { browser: name } }));
        }
    });
}

// Get and set element size
function getElementSize({ elementSelector, targetSelector = 'this', axis = 'both', cssVar }) {
    // Helper function to resolve the element(s)
    const resolveElements = selector => {
        if (typeof selector === 'string') {
            return document.querySelectorAll(selector);
        } else if (selector instanceof NodeList || Array.isArray(selector)) {
            return selector;
        } else {
            return [selector];
        }
    };

    // Resolve the elements and target element
    const elements = resolveElements(elementSelector);
    const targetElement = targetSelector === 'this' ? elements[0] : resolveElements(targetSelector)[0];

    // Exit early if elements are not found or cssVar is not provided
    if (!elements.length || !targetElement || !cssVar) return;

    const calculateAndSetSize = () => {
        let totalWidth = 0;
        let totalHeight = 0;

        // Calculate the total width and height including margins
        elements.forEach(element => {
            const style = window.getComputedStyle(element);
            totalWidth += element.offsetWidth + parseFloat(style.marginLeft || 0) + parseFloat(style.marginRight || 0);
            totalHeight += element.offsetHeight + parseFloat(style.marginTop || 0) + parseFloat(style.marginBottom || 0);
        });

        // Helper function to set CSS variables
        const setCssVariable = (prop, value) => targetElement.style.setProperty(`--${cssVar}${prop}`, `${value}px`);

        // Set the CSS variables based on the axis parameter
        if (axis.includes('width') || axis === 'both') setCssVariable('Width', totalWidth);
        if (axis.includes('height') || axis === 'both') setCssVariable('Height', totalHeight);
    };

    // Initial size calculation
    calculateAndSetSize();

    // Use ResizeObserver to observe changes in the elements' sizes
    const observer = new ResizeObserver(() => {
        calculateAndSetSize();
    });

    // Observe each element
    elements.forEach(element => {
        observer.observe(element);
    });
}


/***
// === [ CORETEX FYI ] ===
// Usage example

getElementSize({
    elementSelector: '.source', // Selects the element to measure
    targetSelector: '.target', // Specifies where to apply the CSS variables. Replace '.target' with 'this' to apply on the same element as '.source'
    axis: 'both', // Indicates that both width and height should be measured and set
    cssVar: 'css-var-target-size' // The base name for the CSS variables to be applied
});

// Explanation of parameters:
- elementSelector: The selector for the element from which to get the size. Here, '.source' is used to find an element with the class 'source'.
- targetSelector: The selector for the target element where the CSS variables will be set. Use 'this' to refer to the same element as 'elementSelector'. Here, '.target' is used to specify a different element with the class 'target'.
- axis: Specifies which dimensions to operate on. It can be 'width', 'height', or 'both'. In this case, 'both' is used to indicate that both dimensions should be processed.
- cssVar: The base name for the CSS variables that will be set on the target element. The function will create '--css-var-target-size-width' and '--css-var-target-size-height' variables if 'both' is selected for the axis.
*/

class MediaQueryUtility {
  constructor() {
    this.breakpoints = {
      mobile: 777,
      tablet: 1024
    };

    this.executeBasedOnViewport = this.executeBasedOnViewport.bind(this);
    this.updateHTMLClass = this.updateHTMLClass.bind(this);

    // Call updateHTMLClass on initialization and resize
    this.updateHTMLClass();
    window.addEventListener('resize', this.updateHTMLClass);
  }

  getViewport() {
    const width = window.innerWidth;
    if (width <= this.breakpoints.mobile) return 'mobile';
    if (width <= this.breakpoints.tablet) return 'tablet';
    return 'desktop';
  }

  executeBasedOnViewport(callbacks = {}) {
    const viewport = this.getViewport();
    const callback = callbacks[viewport];

    // Silently exit if no callback is defined for the viewport
    if (typeof callback !== 'function') return;
    try { callback(); } catch (error) { return; }
  }

  updateHTMLClass() {
    const html = document.documentElement;
    const currentViewport = this.getViewport();
    
    // Remove all viewport classes
    html.classList.remove('mq-mobile', 'mq-tablet', 'mq-desktop');

    // Add the current viewport class
    html.classList.add(`mq-${currentViewport}`);
  }
} const mediaQuery = new MediaQueryUtility(); // Initialize the media query utility

/***
    // === [ CORETEX FYI ] ===
    // Usage example

    // executeBasedOnViewport
    mediaQuery.executeBasedOnViewport({
        mobile: () => {
            console.log('Executing mobile-specific code');
            document.querySelector('drawer-footer').setAttribute('aria-hidden', 'false');
        },
        tablet: () => {
            console.log('Executing tablet-specific code');

        },
        desktop: () => {
            console.log('Executing desktop-specific code'); 
            
        }
    });

*/



// Is in viewport
function inViewport(selector, callback, options = {}, autoUnobserve = false) {
    // Select the elements based on the provided selector. It could be one element or multiple.
    // target single or multiple elements using any valid CSS selector. 
    // This could be a class, ID, tag, or a combination that represents one or more elements.
    const elements = document.querySelectorAll(selector);

    if (!elements.length) {
        console.error(`(inViewport) - No elements found for selector: ${selector}`);
        return;
    }

    // Define the observer with the callback and options.
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            // Execute the callback for each entry.
            callback(entry);

            // Check if autoUnobserve is true and the entry is intersecting, then unobserve.
            if (autoUnobserve && entry.isIntersecting) observer.unobserve(entry.target);
        });
    }, options);

    elements.forEach(element => observer.observe(element));

    // Return the observer instance to allow external control, e.g., manual disconnect.
    return observer;
}


/***
// === [ CORETEX FYI ] ===
// Example usage

// Observing multiple items
const observer = inViewport('.item-to-observe, [data-to-observe]', entry => {
    if (entry.isIntersecting) {
        console.log('Element is in the viewport!', entry.target);
        // You can do something specific with each element here, like adding a class or triggering animations.
    } else {
        console.log('Element has left the viewport.', entry.target);
    }
}, {}, false); // The last parameter 'false' is for autoUnobserve, modify based on your requirement.

*/

/*** Cart */
const cartToastState = {
    element: null,
    hideTimer: null,
    burstCount: 0,
    lastSuccessAt: 0
};

const lastAddContext = {
    isPdp: false,
    cartType: null,
    timestamp: 0
};
let addRequestInFlight = false;

function openCartDrawer() {
    const cartBox = document.getElementById('cartBox');
    if (cartBox && typeof cartBox.open === 'function') {
        cartBox.open();
        return true;
    }

    // Fallback: trigger existing header opener if dialog instance is unavailable.
    const opener = document.querySelector('[data-open="#cartBox"]');
    if (opener instanceof HTMLElement) {
        opener.click();
        return true;
    }
    return false;
}

function isZhLocale() {
    const lang = (document.documentElement.lang || '').toLowerCase();
    return lang.startsWith('zh');
}

function getCartToastMessage(type, count = 1) {
    const zh = isZhLocale();
    if (type === 'error') return zh ? '加入失敗，請再試一次。' : "Couldn't add item. Please try again.";
    if (count > 1) return zh ? `已加入購物車（x${count}）` : `Added to cart (x${count})`;
    return zh ? '已加入購物車' : 'Added to cart';
}

function ensureCartToast() {
    if (cartToastState.element) return cartToastState.element;

    const toast = document.createElement('div');
    toast.id = 'cartToast';
    toast.className = 'cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    document.body.appendChild(toast);
    cartToastState.element = toast;

    return toast;
}

function showCartToast(type = 'success') {
    const toast = ensureCartToast();
    const now = Date.now();
    const isSuccess = type === 'success';

    if (isSuccess && now - cartToastState.lastSuccessAt <= 1200) {
        cartToastState.burstCount += 1;
    } else {
        cartToastState.burstCount = 1;
    }

    if (isSuccess) cartToastState.lastSuccessAt = now;

    toast.textContent = getCartToastMessage(type, cartToastState.burstCount);
    toast.classList.toggle('is-error', type === 'error');
    toast.classList.add('is-visible');

    clearTimeout(cartToastState.hideTimer);
    cartToastState.hideTimer = setTimeout(() => {
        toast.classList.remove('is-visible');
    }, isSuccess ? 1600 : 2200);
}

let _cartCooldownUntil = 0;
const CART_COOLDOWN_MS = 5000;

document.addEventListener('liquid-ajax-cart:request-start', event => {
    const rs = event?.detail?.requestState;
    if (!rs) return;
    if (Date.now() < _cartCooldownUntil && rs.requestType !== 'get') {
        rs.info.cancel = true;
    }
});

document.addEventListener('liquid-ajax-cart:request-end', event => {
    const rs = event?.detail?.requestState;
    if (!rs) return;
    const ok = rs.responseData?.ok;
    const status = rs.responseData?.status;
    if ((!ok || rs.fetchError) && !rs.info?.cancel) {
        _cartCooldownUntil = Date.now() + (status === 429 ? CART_COOLDOWN_MS * 2 : CART_COOLDOWN_MS);
    }
}, true);

document.addEventListener('liquid-ajax-cart:request-start', event => {
    const requestState = event?.detail?.requestState;
    if (!requestState || requestState.requestType !== 'add') return;

    addRequestInFlight = true;
    document.body.setAttribute('cart-state', 'processing');
});

document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const ajaxCartForm = form.closest('ajax-cart-product-form');
    if (!ajaxCartForm) return;

    // Prevent queue explosion from rapid repeated submits.
    if (addRequestInFlight) {
        event.preventDefault();
        return;
    }

    const isPdpPage = document.body.getAttribute('coretex-page') === 'product';
    const formId = String(form.getAttribute('id') || '');
    const isQuickBuyForm = formId.startsWith('quickBuyFrom-');
    const isPdpForm = isPdpPage && !isQuickBuyForm;

    lastAddContext.isPdp = isPdpForm;
    lastAddContext.cartType = ajaxCartForm.getAttribute('cart-type');
    lastAddContext.timestamp = Date.now();
}, true);

const handledCartEndEvents = new WeakSet();
const cartPerfDebugEnabled = window.location.search.includes('cartPerf=1') || window.__cartPerf === true;

function cartPerfMark(startAt) {
    if (!cartPerfDebugEnabled || typeof performance === 'undefined') return 0;
    return performance.now() - startAt;
}

function scheduleDeferredCartSync(isAddRequest) {
    // For add requests, let critical UI (button state, drawer/toast) settle first.
    const runSync = () => syncCartDetailsState();
    if (typeof requestAnimationFrame !== 'function') {
        setTimeout(runSync, 16);
        return;
    }
    if (isAddRequest) {
        requestAnimationFrame(() => {
            setTimeout(runSync, 0);
        });
        return;
    }
    requestAnimationFrame(runSync);
}

// Handle cart UI state after ajax cart requests
function handleCartRequestEnd(event) {
    if (!event || !event.detail || handledCartEndEvents.has(event)) return;
    handledCartEndEvents.add(event);
    const requestState = event.detail.requestState;
    if (!requestState) return;
    const isAddRequest = requestState.requestType === 'add';
    const perfStart = cartPerfDebugEnabled && typeof performance !== 'undefined' ? performance.now() : 0;

    // # Update header cart counter
    const itemCount = window.liquidAjaxCart?.cart?.item_count ?? 0; // Get the item count
    document.querySelectorAll('[data-count]').forEach(function(el) {
        const nextCount = String(itemCount);
        if (el.getAttribute('data-count') !== nextCount) {
            el.setAttribute('data-count', nextCount); // Update only when changed
        }
    });
    const afterCounterMs = cartPerfMark(perfStart);

    // # If the "add to cart" request is successful
    if (isAddRequest && requestState.responseData?.ok) {
        // PDP main form opens drawer; collection/quick-buy keeps toast.
        if (lastAddContext.isPdp) {
            if (lastAddContext.cartType === 'redirect') {
                const cartUrl = window.routes?.cart_url || '/cart';
                window.location.href = cartUrl;
            } else if (!openCartDrawer()) {
                showCartToast('success');
            }
        } else {
            // Collection / quick add keeps toast only.
            showCartToast('success');
        }
    } else if (isAddRequest) {
        showCartToast('error');
    }
    const afterFeedbackMs = cartPerfMark(perfStart);

    // # Remove the "processing" attribute when the "add to cart" request has finished
    if (isAddRequest) {
        addRequestInFlight = false;
        document.body.removeAttribute('cart-state');
        document.body.setAttribute('cart-state', 'done');
        setTimeout(function() { document.body.removeAttribute('cart-state') }, 900);
    }
    const afterStateMs = cartPerfMark(perfStart);

    scheduleDeferredCartSync(isAddRequest);

    if (cartPerfDebugEnabled) {
        console.log('[cartPerf] request-end', {
            type: requestState.requestType,
            ok: Boolean(requestState.responseData?.ok),
            counterMs: Number(afterCounterMs.toFixed(1)),
            feedbackMs: Number(afterFeedbackMs.toFixed(1)),
            stateMs: Number(afterStateMs.toFixed(1)),
            handlerMs: Number(cartPerfMark(perfStart).toFixed(1))
        });
    }
}

// Listen at window capture phase so custom coretexJS document interceptors do not block this flow.
window.addEventListener('liquid-ajax-cart:request-end', handleCartRequestEnd, true);

// (Cart) Fix for details to stay open
const cartDetailsOpen = {};
function isCartDrawerOpen() {
    const cartBox = document.getElementById('cartBox');
    if (!cartBox) return false;
    const innerDialog = cartBox.querySelector('dialog');
    return Boolean(innerDialog?.hasAttribute('open') || document.body.classList.contains('o-cartBox'));
}

function syncCartDetailsState() {
    // Keep bindings fresh even when drawer is closed (ajax may replace nodes).
    cartDetailsInit();
    // Only sync open state when drawer is visible to avoid unnecessary post-request work.
    if (!isCartDrawerOpen()) return;
    document.querySelectorAll('[data-ajax-cart-section] [data-ajax-cart-details]').forEach($details => {
        const key = $details.getAttribute('data-ajax-cart-details');
        if (!key) return;
        if (key in cartDetailsOpen) {
            $details.open = cartDetailsOpen[key];
        }
    });
}

function cartDetailsInit() {
  document.querySelectorAll('[data-ajax-cart-section] [data-ajax-cart-details]').forEach($details => {
    const key = $details.getAttribute('data-ajax-cart-details');
    if (!key) return;
    cartDetailsOpen[key] = $details.hasAttribute('open');
    if ($details.hasAttribute('data-details-bound')) return;
    $details.setAttribute('data-details-bound', 'true');
    $details.addEventListener('toggle', event => {
        cartDetailsOpen[key] = event.target.open;
    });
  });
}
cartDetailsInit();

function _applyCartConf() {
    if (!window.liquidAjaxCart?.conf) return false;
    window.liquidAjaxCart.conf("updateOnWindowFocus", false);
    window.liquidAjaxCart.conf("extraRequestOnError", false);
    if (isZhLocale()) {
        window.liquidAjaxCart.conf("requestErrorText", "更新購物車時發生錯誤，請稍後再試。");
    }
    return true;
}

if (!_applyCartConf()) {
    document.addEventListener('liquid-ajax-cart:init', function() {
        _applyCartConf();
    });
}

// # Remove autofocus from inputs on Safari
window.addEventListener('user-agent', (event) => {
    if (event.detail.browser === 'safari') {
        document.querySelectorAll('[autofocus]').forEach(input => { input.removeAttribute('autofocus') });
        // console.log('Autofocus removed for Safari.');
    }
});

/***
 * 
 * 
 * Event Listeners
 * === [ CORETEX FYI ] ===
 * You may use 1 (one) eventlistener for all methods
 * 
 * 
*/

// Avoid repeating the same code by encapsulating the repeated logic into a function that you call from multiple places. 
// This way, if you need to update the logic later, you only have to do it in one place.
// this function will run on both "DOM ready" and "Resize".
function globalTasks() {
    getSetVh(); // Update viewport height
    getElementSize({ elementSelector: '[class*="group-header-group"]', targetSelector: '#pageBody', axis: 'height', cssVar: 'headerGroup' }); // Get header group height
    getElementSize({ elementSelector: '#mainHeader', targetSelector: '#pageBody', axis: 'height', cssVar: 'header' }); // Get header height
    // executeBasedOnViewport
    mediaQuery.executeBasedOnViewport({
        mobile: () => {
            // console.log('media query: mobile');
            document.querySelector('drawer-footer').setAttribute('aria-hidden', 'false');
        },
        tablet: () => {
            // console.log('media query: tablet')
        },
        desktop: () => {
            // console.log('media query: desktop')
            document.querySelector('drawer-footer').setAttribute('aria-hidden', 'true');
        }
    });
}

// Keydown event handler for filter box
function filterBoxKeydown(event) {
    // Close filters box when ESC key is pressed
    if (event.key === 'Escape' && document.body.classList.contains('filtersBox-o')) document.body.classList.remove('filtersBox-o');
}

/**
 * Handles the Enter key press event for checkboxes and radio buttons.
 */
function handleEnterKey(event) {
    // Check if the Enter key is pressed
    if (event.key === 'Enter') {
        const activeElement = document.activeElement;
    
        // Ensure the focused element is either a checkbox or a radio button
        if (activeElement.tagName === 'INPUT' && ['checkbox', 'radio'].includes(activeElement.type)) {
            // Prevent default behavior
            event.preventDefault();
        
            // Trigger the click event to toggle/select the input
            activeElement.click();
        }
    }
}

function handleSwatchKeydown(event) {
    const swatchTrigger = event.target.closest('.swatch-wrapper[data-variant-url]');
    if (!swatchTrigger) return;

    const variantUrl = swatchTrigger.getAttribute('data-variant-url');
    if (!variantUrl) return;

    if (event.key === 'Enter' || event.key === ' ') {
        if (event.key === ' ' && event.repeat) return;
        event.preventDefault();
        if (event.metaKey || event.ctrlKey) {
            window.open(variantUrl, '_blank');
        } else {
            window.location.href = variantUrl;
        }
    }
}

// ===[ Global click listener ] ===
document.addEventListener('click', (event) => {
    const mediaNav = event.target.closest('[data-media-prev],[data-media-next]');
    if (mediaNav) {
        event.preventDefault();
        event.stopPropagation();
        const wrap = mediaNav.closest('.pc-media-swipe-wrap');
        const card = wrap ? wrap.closest('product-card') : null;
        const swiper = wrap ? wrap.querySelector('.pc-media-swipe') : null;
        if (!swiper) return;
        const direction = mediaNav.hasAttribute('data-media-next') ? 1 : -1;
        if (swiper.hasAttribute('data-js-slider')) {
            if (card) card.setAttribute('data-media-interacted', 'true');
            updateMediaSlider(swiper, direction);
            return;
        }
        return;
    }

    const swatchTrigger = event.target.closest('.swatch-wrapper[data-variant-url]');
    if (swatchTrigger) {
        const variantUrl = swatchTrigger.getAttribute('data-variant-url');
        if (variantUrl) {
            if (event.metaKey || event.ctrlKey) {
                window.open(variantUrl, '_blank');
            } else {
                window.location.href = variantUrl;
            }
        }
        return;
    }
    // if (event) sampleMethod(event);
}, false);

// ===[ JS slider helpers ]===
function getSliderData(swiper) {
    const track = swiper.querySelector('.pc-media-track');
    if (!track) return null;
    const count = track.children.length || 0;
    const index = parseInt(swiper.getAttribute('data-index') || '0', 10);
    return { track, count, index };
}

function setSliderIndex(swiper, index) {
    const data = getSliderData(swiper);
    if (!data || data.count === 0) return;
    const clamped = Math.max(0, Math.min(index, data.count - 1));
    swiper.setAttribute('data-index', String(clamped));
    const width = swiper.clientWidth || 0;
    if (!width) return;
    data.track.style.transform = `translateX(-${clamped * width}px)`;
}

function updateMediaSlider(swiper, direction) {
    const data = getSliderData(swiper);
    if (!data) return;
    setSliderIndex(swiper, data.index + direction);
}

function initMediaSliders(root = document) {
    const swipers = root.querySelectorAll('.pc-media-swipe[data-js-slider="true"]');
    swipers.forEach((swiper) => {
        if (swiper.hasAttribute('data-slider-init')) return;
        swiper.classList.remove('scroll-snap', 'scroll-snap-s', 'mandatory');
        swiper.style.scrollSnapType = 'none';
        swiper.style.overflowX = 'hidden';
        swiper.setAttribute('data-slider-init', 'true');
        swiper.setAttribute('data-index', '0');
        setSliderIndex(swiper, 0);

        let startX = 0;
        let startY = 0;
        let isDragging = false;
        const isTouch = 'ontouchstart' in window || (navigator.maxTouchPoints || 0) > 0;

        if (!isTouch) {
            swiper.addEventListener('pointerdown', (e) => {
                if (e.pointerType && e.pointerType !== 'mouse') return;
                startX = e.clientX;
                startY = e.clientY;
                isDragging = true;
            });
            swiper.addEventListener('pointerup', (e) => {
                if (!isDragging) return;
                const delta = e.clientX - startX;
                if (Math.abs(delta) > 40) {
                    updateMediaSlider(swiper, delta < 0 ? 1 : -1);
                }
                isDragging = false;
            });
            swiper.addEventListener('pointerleave', () => {
                isDragging = false;
            });
        } else {
            let touchActive = false;
            swiper.addEventListener('touchstart', (e) => {
                const touch = e.touches && e.touches[0];
                if (!touch) return;
                startX = touch.clientX;
                startY = touch.clientY;
                touchActive = true;
            }, { passive: true });
            swiper.addEventListener('touchmove', (e) => {
                if (!touchActive) return;
                const touch = e.touches && e.touches[0];
                if (!touch) return;
                const dx = touch.clientX - startX;
                const dy = touch.clientY - startY;
                if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
                    e.preventDefault();
                }
            }, { passive: false });
            swiper.addEventListener('touchend', (e) => {
                if (!touchActive) return;
                const touch = (e.changedTouches && e.changedTouches[0]) || null;
                if (!touch) return;
                const delta = touch.clientX - startX;
                if (Math.abs(delta) > 40) {
                    updateMediaSlider(swiper, delta < 0 ? 1 : -1);
                }
                touchActive = false;
            });
        }

        const firstImg = swiper.querySelector('img');
        if (firstImg && !firstImg.complete) {
            firstImg.addEventListener('load', () => setSliderIndex(swiper, 0), { once: true });
            firstImg.addEventListener('error', () => setSliderIndex(swiper, 0), { once: true });
        }

        if (window.ResizeObserver) {
            const resizeObserver = new ResizeObserver(() => {
                const index = parseInt(swiper.getAttribute('data-index') || '0', 10);
                setSliderIndex(swiper, index);
            });
            resizeObserver.observe(swiper);
        }
    });
}

// ===[ Collection media hover ]===
document.addEventListener('mouseenter', (event) => {
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (!(event.target instanceof Element)) return;
    const card = event.target.closest('product-card');
    if (!card || card.hasAttribute('data-media-interacted')) return;
    const swiper = card.querySelector('.pc-media-swipe');
    if (!swiper) return;
    if (swiper.hasAttribute('data-js-slider')) {
        setSliderIndex(swiper, 1);
        return;
    }
}, true);

document.addEventListener('mouseleave', (event) => {
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (!(event.target instanceof Element)) return;
    const card = event.target.closest('product-card');
    if (!card || card.hasAttribute('data-media-interacted')) return;
    const swiper = card.querySelector('.pc-media-swipe');
    if (!swiper) return;
    if (swiper.hasAttribute('data-js-slider')) {
        setSliderIndex(swiper, 0);
        return;
    }
}, true);

function getMediaSwipers(root = document) {
    if (!root) return [];
    if (root.classList && root.classList.contains('pc-media-swipe')) {
        if (root.hasAttribute('data-js-slider')) return [];
        return [root];
    }
    const swipers = Array.from(root.querySelectorAll('.pc-media-swipe'));
    return swipers.filter((swiper) => swiper.closest('.collections, .feat-products') && !swiper.hasAttribute('data-js-slider'));
}

function resetCollectionCardMedia(root = document) {
    const swipers = getMediaSwipers(root);
    if (!swipers.length) return;
    swipers.forEach((swiper) => {
        const card = swiper.closest('product-card');
        if (!card) return;
        if (card.hasAttribute('data-media-interacted')) return;
        if (card.hasAttribute('data-reset-done')) return;
        const firstImg = swiper.querySelector('img');
        if (firstImg && !firstImg.complete) return;
        const prevSnap = swiper.style.scrollSnapType;
        const prevBehavior = swiper.style.scrollBehavior;
        swiper.style.scrollSnapType = 'none';
        swiper.style.scrollBehavior = 'auto';
        swiper.scrollLeft = 0;
        requestAnimationFrame(() => {
            swiper.scrollLeft = 0;
            swiper.style.scrollSnapType = prevSnap || '';
            swiper.style.scrollBehavior = prevBehavior || '';
        });
        card.setAttribute('data-reset-done', 'true');
    });
}

let mediaResetTimer;
function scheduleCollectionMediaReset(root = document) {
    clearTimeout(mediaResetTimer);
    mediaResetTimer = setTimeout(() => resetCollectionCardMedia(root), 60);
}

function initCollectionMediaSnap(root = document) {
    const swipers = getMediaSwipers(root);
    if (!swipers.length) return;
    swipers.forEach((swiper) => {
        if (swiper.hasAttribute('data-snap-init')) return;
        swiper.setAttribute('data-snap-init', 'true');
        const card = swiper.closest('product-card');
        if (!card) return;
        swiper.style.scrollSnapType = 'none';
        swiper.style.scrollBehavior = 'auto';
        swiper.scrollLeft = 0;
        const firstImg = swiper.querySelector('img');
        const finalize = () => {
            if (card.hasAttribute('data-media-interacted')) return;
            resetCollectionCardMedia(card);
        };
        if (!firstImg) {
            finalize();
            return;
        }
        if (firstImg.complete) {
            finalize();
        } else {
            firstImg.addEventListener('load', finalize, { once: true });
            firstImg.addEventListener('error', finalize, { once: true });
        }
    });
}

const mediaObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const swiper = entry.target;
        const card = swiper.closest('product-card');
        if (!card) return;
        initCollectionMediaSnap(card);
        resetCollectionCardMedia(card);
    });
}, { rootMargin: '200px 0px', threshold: 0.01 });

function observeMediaSwipers(root = document) {
    const swipers = getMediaSwipers(root);
    if (!swipers.length) return;
    swipers.forEach((swiper) => {
        if (swiper.hasAttribute('data-observed')) return;
        swiper.setAttribute('data-observed', 'true');
        swiper.scrollLeft = 0;
        swiper.style.scrollSnapType = 'none';
        mediaObserver.observe(swiper);
        swiper.addEventListener('scroll', () => {
            if (swiper.scrollLeft <= 0) return;
            const card = swiper.closest('product-card');
            if (!card) return;
            card.classList.add('media-snap-enabled');
            card.setAttribute('data-media-interacted', 'true');
        }, { passive: true });
    });
}

// ===[ Global keydown listener ] ===
document.addEventListener('keydown', (event) => {
    if (event) filterBoxKeydown(event);
    if (event) handleEnterKey(event);
    if (event) handleSwatchKeydown(event);
}, false);


/*** 
// === [ CORETEX FYI ] ===
// Example usage

function sampleMethod(event) {
    const element = event.target.closest("[data-some-attr]"); // add your element class/id/data-attr.
    if (element) {
        event.preventDefault();
        //.... your logic here
    }
}
*/

// Code to be executed when the window is resized.
/***
 * === [ CORETEX FYI ] ===
 * We throttle/debounce the execution of functions to avoid performance issues.
*/
let debouncerId;
window.addEventListener('resize', () => {
    clearTimeout(debouncerId);
    debouncerId = setTimeout(() => {
        globalTasks(); // Run Global tasks
        // put other functions here
    }, 222); // Adjust delay as needed
});

// Code to be executed when DOM is ready.
document.addEventListener('DOMContentLoaded', function() {
    getNavigator(); // get user's device and browser
    globalTasks(); // Run Global tasks
    resetCollectionCardMedia();
    setTimeout(resetCollectionCardMedia, 120);
    setTimeout(resetCollectionCardMedia, 420);
    initCollectionMediaSnap();
    observeMediaSwipers();
    initMediaSliders();
    // put other functions Here
});

window.addEventListener('resize', () => {
    const swipers = document.querySelectorAll('.pc-media-swipe[data-js-slider="true"][data-slider-init="true"]');
    swipers.forEach((swiper) => {
        const index = parseInt(swiper.getAttribute('data-index') || '0', 10);
        setSliderIndex(swiper, index);
    });
});

window.addEventListener('load', () => {
    resetCollectionCardMedia();
    initCollectionMediaSnap();
    observeMediaSwipers();
    initMediaSliders();
});

// Re-apply on infinite load (collection)
document.addEventListener('component-loaded', (evt) => {
    if (!evt || !evt.detail) return;
    const target = evt.detail.target || evt.target;
    if (!target) return;
    scheduleCollectionMediaReset(target);
    initCollectionMediaSnap(target);
    observeMediaSwipers(target);
    initMediaSliders(target);
});

document.addEventListener('infinity:items-appended', (evt) => {
    const target = evt.detail && evt.detail.target ? evt.detail.target : document;
    initMediaSliders(target);
});

if (window.MutationObserver) {
    const observer = new MutationObserver((mutations) => {
        let needsReset = false;
        let root = document;
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (!node || node.nodeType !== 1) return;
                const element = node;
                if (element.matches('.pc-media-swipe') || element.querySelector('.pc-media-swipe')) {
                    needsReset = true;
                    root = element;
                }
            });
        });
        if (needsReset) {
            scheduleCollectionMediaReset(root);
            initCollectionMediaSnap(root);
            observeMediaSwipers(root);
            initMediaSliders(root);
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

// Code to be executed when in the theme editor
if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
        getNavigator(); // get user's device and browser
        globalTasks(); // Run Global tasks
        // put other functions here
    });
}

/***
 * === [ CORETEX FYI ] ===
 * Fires on every component load and holds name of loaded component and other not loaded components
 * 🚨 Remove in production.
*/
// document.addEventListener('component-loaded', (evt) => console.log(evt.detail));